/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Markers_Comment_PlaceholderInputs */

const en_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add a comment here`)
};

const fr_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un commentaire ici`)
};

const de_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hier einen Kommentar hinzufügen`)
};

const it_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi un commento qui`)
};

const ru_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оставьте комментарий здесь`)
};

const es_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añade un comentario aquí`)
};

const zh_cn2_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在此处添加评论`)
};

const ja_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ここにコメントを追加`)
};

const hi_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यहां एक टिप्पणी जोड़ें`)
};

const pt_pt2_markers_comment_placeholder = /** @type {(inputs: Markers_Comment_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicione um comentário aqui`)
};

/**
* | output |
* | --- |
* | "Add a comment here" |
*
* @param {Markers_Comment_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const markers_comment_placeholder = /** @type {((inputs?: Markers_Comment_PlaceholderInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Markers_Comment_PlaceholderInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_markers_comment_placeholder(inputs)
	if (locale === "de") return de_markers_comment_placeholder(inputs)
	if (locale === "it") return it_markers_comment_placeholder(inputs)
	if (locale === "ru") return ru_markers_comment_placeholder(inputs)
	if (locale === "es") return es_markers_comment_placeholder(inputs)
	if (locale === "zh-CN") return zh_cn2_markers_comment_placeholder(inputs)
	if (locale === "ja") return ja_markers_comment_placeholder(inputs)
	if (locale === "hi") return hi_markers_comment_placeholder(inputs)
	if (locale === "pt-PT") return pt_pt2_markers_comment_placeholder(inputs)
	return en_markers_comment_placeholder(inputs)
});